import { IPaymentMethod, IPaymentState } from "./types";

export const initialState: IPaymentState = {
	paymentMethods: [] as IPaymentMethod[],
	errorMessage: null,
	paymentReference: null,
	paymentData: null,
};
